"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheArchitectSEntry() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: subRef,
    isVisible: subVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  return <section data-section-id="2272" id="the-architects-entry" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0 z-30 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='50' height='50'><rect width='50' height='50' fill='none' stroke='currentColor' stroke-width='0.5'/></svg>\")"
    }} aria-hidden="true" />

      {}
      <div ref={imgRef} className={`absolute inset-y-0 right-0 z-10 w-full md:w-[65%] lg:w-[60%] transition-all duration-[1400ms] ease-out ${imgVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="relative h-full w-full">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695823/img/luxury_financial_architecture_skyline.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695823/img/luxury_financial_architecture_skyline.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695823/img/luxury_financial_architecture_skyline.png-wvc-sizes" alt="High-end architectural office overlooking a city skyline at dusk" className="h-full w-full object-cover object-center opacity-40 md:opacity-70 grayscale contrast-125" loading="lazy" decoding="async" />
          {}
          <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-transparent md:via-background/60" />
          <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-background/50" />
        </div>
      </div>

      {}
      <div className="absolute top-0 right-4 md:right-6 z-20 hidden sm:flex h-full items-start pt-24 lg:pt-32">
        <div className="overflow-hidden h-[60vh]" style={{
        writingMode: "vertical-rl"
      }}>
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-primary/40 whitespace-nowrap" style={{
          animation: "valveMarquee 25s linear infinite"
        }}>
            STRATEGIC WEALTH — CAPITAL ARCHITECTURE — ELITE FUNDING — STRATEGIC WEALTH — CAPITAL ARCHITECTURE — ELITE FUNDING —
          </div>
        </div>
        <style>{`
          @keyframes valveMarquee {
            0% { transform: translateY(-50%); }
            100% { transform: translateY(0%); }
          }
        `}</style>
      </div>

      {}
      <div className="relative z-20 mx-auto flex min-h-screen max-w-[1600px] flex-col justify-end px-5 sm:px-8 lg:px-12 pt-28 pb-20 md:pb-28">
        {}
        <div ref={eyebrowRef} className={`mb-10 md:mb-16 flex items-center gap-4 transition-all duration-700 ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-mono text-[12px] uppercase tracking-[0.2em] font-bold" style={{
          color: "var(--primary)"
        }}>
            § 01 / BENEWEALTH FINANCIAL
          </span>
          <span className="h-px flex-1 max-w-[120px] sm:max-w-[180px]" style={{
          backgroundColor: "var(--primary)"
        }} />
        </div>

        {}
        <div ref={headlineRef} className={`transition-all duration-1000 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-serif font-medium uppercase leading-[1.1] text-foreground" style={{
          fontSize: "clamp(2.5rem, 8vw, 6rem)",
          letterSpacing: "-0.02em"
        }}>
            WE DON'T JUST <span style={{
            color: "transparent",
            WebkitTextStroke: "1px var(--primary)"
          }}>
              REPAIR
            </span> CREDIT. WE <span className="text-primary">ARCHITECT</span> FINANCIAL SOLUTIONS.
          </h1>
        </div>

        {}
        <div ref={subRef} className={`mt-8 md:mt-12 max-w-[50ch] transition-all duration-700 delay-100 ${subVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="font-default text-lg sm:text-xl text-foreground/80 leading-relaxed">
            Benewealth Financial helps qualified clients strengthen personal credit, build business credit, access real funding solutions, and create strategic pathways toward wealth-building.
          </p>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-widest text-primary/70">
            No Social Security number required to begin. No hard credit pull for initial qualification review.
          </p>
        </div>

        {}
        <div ref={ctaRef} className={`mt-10 md:mt-12 flex flex-col sm:flex-row gap-4 sm:gap-5 transition-all duration-700 delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Link to="/QualificationApplicationPage">
            <Button size="lg" className="h-14 px-8 font-default font-bold uppercase tracking-wider text-sm bg-primary text-primary-foreground hover:bg-primary/90 rounded-md shadow-xl transition-transform hover:scale-[1.02]" style={{
            boxShadow: "0 20px 50px -10px hsl(43 45% 65% / 0.3)"
          }}>
              START THE QUALIFICATION APPLICATION
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>

          <Link to="/ServicesPage">
            <Button size="lg" variant="outline" className="h-14 px-8 font-default font-bold uppercase tracking-wider text-sm bg-transparent border border-primary/40 text-foreground hover:bg-primary hover:text-primary-foreground rounded-md">
              OUR SERVICES
            </Button>
          </Link>
        </div>

        {}
        <div className="mt-16 md:mt-20 flex items-end justify-between gap-6">
          {}
          <div className="flex flex-col items-center gap-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.4em] text-primary/60" style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)"
          }}>
              ASCEND
            </span>
            <span className="block w-px h-16 md:h-20" style={{
            background: "linear-gradient(to bottom, var(--primary), transparent)",
            animation: "valveScrollPulse 2.4s ease-in-out infinite"
          }} />
            <style>{`
              @keyframes valveScrollPulse {
                0%, 100% { opacity: 0.3; transform: scaleY(0.7); transform-origin: top; }
                50% { opacity: 1; transform: scaleY(1); transform-origin: top; }
              }
            `}</style>
          </div>

          {}
          <div className="hidden md:flex flex-col items-end gap-1 font-mono text-[11px] uppercase tracking-[0.15em] text-foreground/70">
            <div className="flex items-center gap-3">
              <span className="inline-block h-1.5 w-1.5 rounded-md" style={{
              backgroundColor: "var(--primary)",
              boxShadow: "0 0 8px var(--primary)"
            }} />
              <span>SELECTIVE ADMISSIONS</span>
            </div>
            <div>ESTABLISHED MMXXIV</div>
            <div style={{
            color: "var(--primary)"
          }}>ELITE TIER</div>
          </div>
        </div>
      </div>
    </section>;
}